import React from 'react'
import { designTokens } from '@/utils/design-tokens'
import { AlertCircle } from 'lucide-react'

const NoWorkspaceScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-6">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center"
            style={{ backgroundColor: designTokens.colors.gray[1] }}
          >
            <AlertCircle
              size={32}
              style={{ color: designTokens.colors.gray[4] }}
            />
          </div>
        </div>

        {/* Title */}
        <h1
          className="mb-4"
          style={{
            fontFamily: designTokens.typography.fontFamily.sans[0],
            fontSize: designTokens.typography.fontSize['title-large'][0],
            lineHeight: designTokens.typography.fontSize['title-large'][1].lineHeight,
            fontWeight: 700,
            color: designTokens.colors.gray[6]
          }}
        >
          워크스페이스가 없습니다
        </h1>

        {/* Message */}
        <p
          className="mb-8"
          style={{
            fontFamily: designTokens.typography.fontFamily.sans[0],
            fontSize: designTokens.typography.fontSize['body-large'][0],
            lineHeight: designTokens.typography.fontSize['body-large'][1].lineHeight,
            fontWeight: 400,
            color: designTokens.colors.gray[5]
          }}
        >
          등록된 워크스페이스가 없습니다.<br />
          관리자에게 문의해주세요.
        </p>

        {/* Contact Info or Additional Message */}
        <div
          className="p-4 rounded-lg"
          style={{ backgroundColor: designTokens.colors.gray[0] }}
        >
          <p
            style={{
              fontFamily: designTokens.typography.fontFamily.sans[0],
              fontSize: designTokens.typography.fontSize['body-small'][0],
              lineHeight: designTokens.typography.fontSize['body-small'][1].lineHeight,
              fontWeight: 400,
              color: designTokens.colors.gray[4]
            }}
          >
            워크스페이스 접근 권한이 필요한 경우<br />
            시스템 관리자에게 연락하여 도움을 요청하세요.
          </p>
        </div>
      </div>
    </div>
  )
}

export default NoWorkspaceScreen